import React, { Component } from 'react';
import { Radio, Checkbox, Rate, Pagination, Spin } from 'antd';
import moment from 'moment';
import { inject, observer } from 'mobx-react';
import { getJson } from "@/method";
import "./index.scss"

const listName = {
    'all': "全部 Total",
    'ctrip': "携程 Ctrip",
    'feizhu': '飞猪 Fliggy',
    'meituan': '美团点评 Meituan & Dianping',
    'yilong': "同城艺龙 Tongcheng & Yilong",
    'qunar': '去哪儿 Qunar',
    'lvmama': '驴妈妈',
}

@inject('store')
@observer
class index extends Component {
    constructor(props) {
        super(props);
        this.state = {
            date: moment().subtract(1, 'month').format('YYYY-MM'),
            area_obj: {
                'ctrip': { name: '携程', bg: '#4C9BF2' },
                'feizhu': { name: '飞猪', bg: '#F6C50E' },
                'meituan': { name: '美团<br/>点评', bg: '#ffc301' },
                'yilong': { name: '同城<br/>艺龙', bg: '#24BC81' },
                'qunar': { name: '去哪儿', bg: '#10A8BC' },
                'lvmama': { name: '驴妈妈', bg: '#d60d7f' },
            },
        }
    }

    async componentDidMount() {
        this.props.store.groupChannels.getDataCount(this.props.store.groupChannels.rival);
        this.props.store.groupChannels.getData('5.0', '', '', 1, '1', this.props.store.groupChannels.rival);
        this.props.store.groupChannels.getRival();
    }

    getRateScore = (score = 0) => {
        return (score / 10).toFixed(1)
    }

    getTime = (x) => {
        let time = '';
        switch (x.platform) {
            case 'ctrip':
                time = x.createTime.slice(10, 20);
                break;
            case 'qunar':
                time = x.createTime.slice(20, -18).replace(/\D/gm, '-');
                break;
            case 'yilong':
                time = x.createTime;
                break;
            case 'meituan':
                time = x.createTime.slice(33, -19)
                break;
            case 'feizhu':
                time = x.createTime.slice(0, 10)
                break;
            default:
                break;
        }
        return time;
    }

    render() {
        const { radioChange, checkVal, checkChange, onChangePage, data, list_count = [], comments_loading, page, total, area } = this.props.store.groupChannels;
        return (
            <div className='groupOfChannels_comments'>
                <Spin spinning={comments_loading}>
                    <div className='select_area' id='select_area'>
                        <Radio.Group defaultValue="all" buttonStyle="solid" className="radio_platform" onChange={radioChange}>
                            {(list_count || []).map(item => {
                                return <Radio.Button value={item.name}><div className='f-center'>{listName[item.name]}<span className='f_s_16'>（{item.num}）</span></div></Radio.Button>
                            })}
                        </Radio.Group>
                        <Checkbox.Group style={{ width: '100%' }} value={checkVal} onChange={checkChange} className='check_conditions'>
                            <div style={{ marginRight: 30 }}>
                                <Checkbox value="bad"><span className='text'>差评内容 Negative Comments<span>（{(list_count.find(x => x.name == area) || {}).bad}）</span></span></Checkbox>
                            </div>
                            <div>
                                <Checkbox value="no_response"><span className='text'>未回复点评 No Reply<span>（{(list_count.find(x => x.name == area) || {}).unanswered}）</span></span></Checkbox>
                            </div>
                        </Checkbox.Group>
                    </div>
                    <div className='comments'>
                        {(data || []).map((x, i) => {
                            return (
                                <div className='each_list'>
                                    <div className='left'>
                                        <div style={{ background: `${getJson([x.platform, 'bg'], this.state.area_obj, "rgb(211, 208, 208)")}` }} className='area' dangerouslySetInnerHTML={{ __html: getJson([x.platform, 'name'], this.state.area_obj, "其他") }}></div>
                                        <div className='left_text'>
                                            <div className='score'>
                                                {(x.score / 10).toFixed(1) || "0"}分
                                            <Rate disabled allowHalf className='star' value={this.getRateScore(x.score || '0')} />
                                            </div>
                                            <div className='time'>{x.add_time ? moment(x.add_time).format('YYYY-MM-DD') : ""}</div>
                                        </div>
                                    </div>
                                    <div className='content'>{x.content}</div>
                                </div>
                            )
                        })}

                        {/* <div className="foot-pagination">
                        <Pagination
                            showSizeChanger
                            // onShowSizeChange={onShowSizeChange}
                            defaultCurrent={3}
                            total={500}
                        />
                    </div> */}
                    </div>
                    <div className='pagination'>
                        <Pagination showQuickJumper defaultCurrent={1} current={page} total={total} onChange={onChangePage} pageSize={10} />
                    </div>
                </Spin>
            </div >
        );
    }
}

export default index;


// WEBPACK FOOTER //
// ./src/components/table/guestRating/channels/comments.js